<template>
    <new-address-form-base :countries="countries">
        <template slot-scope="{ newAddressType, setNewAddressType, address, errors, create }">
            <div class="card border-0 pb-3">
                <div class="card-body">
                    <create-billing-address-modal
                        :countries="countries"
                        :show-modal.sync="openBillingModal"
                    ></create-billing-address-modal>
                    <create-shipping-address-modal
                        :countries="countries"
                        :show-modal.sync="openShippingModal"
                    ></create-shipping-address-modal>
                </div>

                <shipping-address-selector
                    v-model="shippingAddress"
                    :addresses="shippingAddresses"
                    :countries="countries"
                >
                    <template v-slot:header>
                    <span class="shipping-addresses-title">
                        <b>{{ __('Shipping Addresses') }}</b>
                    </span>
                    </template>
                </shipping-address-selector>

                <billing-address-selector
                    v-model="billingAddress"
                    :addresses="billingAddresses"
                    :countries="countries"
                >
                    <template v-slot:header>
                <span class="billing-addresses-title">
                    <b>{{ __('Billing Addresses') }}</b>
                </span>
                    </template>
                </billing-address-selector>
            </div>
        </template>
    </new-address-form-base>
</template>

<script>
export default {
    name: 'NewAddressForm',
    props: {
        countries: {
            type: Array,
            required: true
        },
        defaultShippingAddresses: {
            type: Array,
            required: true
        },
        defaultBillingAddresses: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            openModal: false,
            openShippingModal: false,
            openBillingModal: false,
            shippingAddress: null,
            billingAddress: null,
            shippingAddresses: this.defaultShippingAddresses,
            billingAddresses: this.defaultBillingAddresses,
        }
    },
}
</script>
